<template>
  <div>
    <b-overlay :show="loading">
      <main-title title="Novedades" />
      <div class="row mx-0">
        <div class="col-4">
          <small-news :data="novedades[0]"></small-news>
        </div>
        <div class="col-4">
          <small-news :data="novedades[1]"></small-news>
        </div>
        <div class="col-4">
          <small-news :data="novedades[2]"></small-news>
        </div>
      </div>
      <!--
      <div class="my-2 py-2 text-right" style="font-weight: bold;">
        Ver todas las novedades
        <b-button
          class="rounded-circle"
          style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
          to="/noticias/Novedades"
        >
          <b-icon icon="chevron-right" />
        </b-button>
      </div>-->
      <b-card
        :img-src="starry.image"
        img-alt="Card image"
        img-left
        class="my-4"
      >
        <div
          style="font-family: 'Poppins', sans-serif; font-size: x-small; margin-top: 1rem; color: rgba(0,0,0,.5);"
        >
          {{starry.publishdate}}
        </div>
        <div>
          <div
            style="font-weight: bold; line-height: 1.2rem; margin-bottom: .25rem;"
          >
            <span v-html="starry.title"></span>
          </div>
          <div style="font-size: small;">
            <span v-html="starry.description"></span>
          </div>
        </div>
        <div class="my-2 py-2 text-right" style="font-weight: bold;">
          Leer artículo
          <b-button
            class="rounded-circle"
            style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
             @click="openStarry();"
          >
            <b-icon icon="chevron-right" />
          </b-button>
        </div>
      </b-card>
      <main-title title="Lo más visto" />
      <div class="row" style="margin: 0px -1rem;">
        <div class="col-4"><micro-news order="1" :data="topviews[0]"></micro-news></div>
        <div class="col-4"><micro-news order="2" :data="topviews[1]"></micro-news></div>
        <div class="col-4"><micro-news order="3" :data="topviews[2]"></micro-news></div>
      </div>      
      <main-title title="NOTAS DE PRENSA" />
      <div class="d-flex flex-wrap" style="margin: 0px -1rem;">
        <big-news :data="novedades[3]" />
        <big-news :data="novedades[4]" />
        <big-news :data="novedades[5]" />
        <big-news :data="novedades[6]" />
      </div>
      <div class="my-2 py-2 text-right" style="font-weight: bold;">
        Ver todas las notas
        <b-button
          class="rounded-circle"
          style="width: 1.5rem;padding-left: 0.3rem;padding-top: 2px;height: 1.5rem;margin-top: -0.2rem;font-size: x-small;text-align: center;"
          to="/noticias/Prensa"
        >
          <b-icon icon="chevron-right" />
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import SmallNews from "@/components/Noticias/Small.vue";
import MicroNews from "@/components/Noticias/Micro.vue";
import BigNews from "@/components/Noticias/Big.vue";
import axios from "axios";

export default {
  components: {
    MainTitle,
    SmallNews,
    MicroNews,
    BigNews
  },
  data() {
    return {
      novedades: [],
      topviews: [],
      starry: {image: '', publishdate:'', title: '', description: '' },
      loading: true
    }
  },
  mounted(){
    this.updatenews();
  },
  methods:{
    async updatenews(){
      console.log(this.$store.state.user.siteData);

      this.novedades = await axios
        .post(
          this.$store.state.user.siteData.location + "news/news/getAll",
          JSON.stringify({type: 'dashboard'}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.loading = false;
          const records = evtResponse.data.records; 
          this.topviews = records.topviews;
          this.starry = records.starry[0];
          return records.news;
        });
    },
    openStarry(){
      if (this.starry.internal === "1"){
        this.$router.push("/noticias/detalle/" + this.starry.id);
      }else{
        window.open(this.starry.url, '_blank');
      }
    }
  }
};
</script>
